import { MatPaginatorDefaultOptions } from "@angular/material/paginator";

export const paginatorDefaultOptions: MatPaginatorDefaultOptions = {
  // MDC defaults the page-size field to "outline"; match the app's other form fields
  formFieldAppearance: "fill"
};
